export const singleSelectFieldItemHeight = "36";
